export const PartyIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="24" height="24" rx="6" fill="url(#pattern0_8315_4755)" />
      <defs>
        <pattern
          id="pattern0_8315_4755"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_8315_4755"
            transform="translate(-0.0217391) scale(0.0434783)"
          />
        </pattern>
        <image
          id="image0_8315_4755"
          width="24"
          height="23"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAXCAIAAACeQxh6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhJREFUeNqklU0orGEUx+d955kxgzEYufeWKGVnYxaKuPYWKAtNKaSUZGPHyty7mhXZDBvZsCE3pGQn+So7aWaEhXwmhZjvmff+Zh69hsbNvfcsptfznPM///M/5zyUH+6fvxYXjUIYNM3wb6Yo3758FZFIOJFMmIVZewukpf7WVEX9BI4SCgcFroQkk8lMoETajEZjLBkzm9/nkGkIUVVVSZuqGrMkxCM3N9ftdk9OTlZXV0ciEf0cdIkSj8fz8vL41XNkAQqFQo2NjW1tbbW1tb29vXhLjuQnAbggDgwMzM7O9vf3a2l7A8T18/NzMBikoqOjo6urK052dnZgDpbD4ZiYmJiZmamvr4dLd3d3eXl5Z2dnUVGRpCkyy3G5XNBZXV09Pj7u6uqy2+0nJydWq5UENTU1dXV1eHZ0dEBnZWWlubl5bW3t/v6exK9AxBM5ODjIN/nn5+fPzs7gbLPZOEHvw8PDQCBQWlpKMKxHRka8Xi8o+FDyKxAWi8X0luXk5CDTw8PDwcEBCU0m0+XlJXqBSMrR0VEcpqamCOFKRr0AwX9hYSGUtqWlpb6+PthBDTl3d3ctFosQAiK3t7c9PT0IRMjT09PY2Nh7IOjRjrm5OdndsrKy1J0QhYWFeoOhBqObmxs5QXCkD3pBr6XJ7kqNpqenHx8fkWBzc5MqdB+obWxswBdPGkodWYB0g+35+bnH4yEhrnJ8o9GoHCiw9vb2oMlHdkaZ4y/SFg6H0YUATiorK9vb209PT1EQjpkQHwJJI7/T6ayoqNja2rq4uBgaGmpoaOAcrP39fdA/BUQhQLBrlLa+vk4Hr6+vZafQDjqQ5TdTvuxA1IJSUksaR/7x8fHt7W32hlnnimVmiHw+Hwq89LTpe5M/4BemN4h0mpZRBarTQSaTKfX7/Xd3d3y0tLSwd62trYwrPqmUFqv46K3CWLrl5WX4yyeJXeUK+auqquSUsbdyY/8kthx3vVL9EFDmtri4mAFGPl118bcPNIUw3MPDw/Jbrn4KCG7pt1LVPv34Q8pkTq2YYlCkDol4XBTYC/Lz84VR/Mc/EYOjpOS3AAMAvhfSZax6JR4AAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
};
